import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Home from './components/Home';
import Services from './components/Services';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactForm from './components/ContactForm';
import HeroSection2 from './components/HeroSection2';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactUs from './pages/ContactPage';


import AboutPage from './pages/AboutUs';

function App() {
  return (
    <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />

          <Route path="/contact" element={<ContactUs />} />
         

        </Routes>
    </Router>
   
  );
}

export default App;
